import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const billRateModStyles = makeStyles<{ isExpanded?: boolean }>()((theme: Theme, { isExpanded }) => ({
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 10px',
  },
  firstField: {
    '@media (min-width: 600px) and (max-width: 1120px)': {
      marginLeft: '12px',
    },
  },
  headerLeft: {
    justifyContent: 'space-between',
    display: 'inline-flex',
    width: '300px',
  },
  fieldsMargin: {
    marginTop: '12px',
  },
  dollarTextfield: {},

  labelFont: {
    fontSize: '12px !important',
    fontWeight: 'bold',
  },
  checkBoxLabel: {
    color: '#333333',
    font: 'normal normal normal 14px/20px Roboto',
  },
  checkBoxLabelGww: {
    color: '#333333 !important',
    font: 'normal normal normal 14px/20px Roboto !important',
  },
  firstAdditionalField: {
    marginBottom: '10px',
    '@media (min-width: 600px) and (max-width: 1120px)': {
      marginLeft: '8px',
    },
  },
  factorMargin: {
    '@media (min-width: 600px) and (max-width: 1120px)': {
      marginLeft: '8px',
    },
    '@media (min-width: 1120px)': {
      marginLeft: '24px',
    },
    marginBottom: '10px',
  },
  divider: {
    marginTop: '12px',
  },
  headings: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#333333',
  },
  tooltip: {
    maxWidth: 500,
  },
  iconClass: {
    height: '14px',
    marginLeft: '-6px',
  },
  flex: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '12px',
  },
  sectionFields: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridGap: '12px',
  },
  paysGwwCheckbox: {
    color: '#333333',
  },
  helperText: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  rateMargin: {
    marginBottom: '10px',
    marginLeft: '10px',
  },
  factorTextfields: {
    width: isExpanded ? '240px' : '216px',
    fontSize: '14px',
    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      marginRight: '0px',
    },
  },
  compTextfields: {
    width: isExpanded ? '300px' : '187px',
    fontSize: '14px',
    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      marginRight: '0px',
    },
  },
  radioLabel: {
    color: '#333333 ',
    ' & .MuiFormControlLabel-label': {
      color: "#333333 !important"
    },
  },
  rateField: {
    width: isExpanded ? '300px' : '249px',
  },
  factorMarginBillRate: {
    '@media (min-width: 600px) and (max-width: 1120px)': {
      marginLeft: '0px',
      marginBottom: '24px'
    },
    '@media (min-width: 1120px)': {
      marginLeft: '24px',
    },
    marginBottom: '10px',
  },
}));
